import bound from 'bound-decorator';
import AsyncComponentUpdateController from './async_component_update_controller';
import { Rails } from 'javascript/utils/rails_polyfills';

export default class extends AsyncComponentUpdateController {
  static targets = ['continueButton', 'drawerContinueButton'];

  async updateAssignmentSelector(e) {
    const assignmentComponentUrl = this.element.dataset.assignmentComponentUrl;
    const assignedTicket = e.detail[0]?.ticket;
    const assignButton = document.querySelector(
      `.ticket-assignment-selector[data-ticket-assignment-selector-id="${assignedTicket.id}"] .ticket-assignment-selector__form-assign-button`,
    );
    const assignForm = document.querySelector('.ticket-purchase-layout');
    assignForm?.classList.add('contents-loading');
    assignButton?.classList.add('contents-loading');

    try {
      if (!assignedTicket) throw new Error('No ticket selected');

      const data = await this.updateComponent({
        componentUrl: assignmentComponentUrl,
        componentSelector: `.ticket-assignment-card[data-ticket-id="${assignedTicket.id}"]`,
        body: { ticket: assignedTicket },
      });

      const unnassignedTickets = data.tickets.filter(
        (ticket) =>
          ticket.assignment_info.current_assignment_type === 'unassigned',
      );
      if (assignedTicket.assignment_info.current_assignment_type === 'friend')
        await this.updateTicketsFriendSelections(
          unnassignedTickets,
          assignmentComponentUrl,
        );

      this.setContinueButton(data.tickets);
    } catch (err) {
      console.error(err);
    }

    Rails.fire(this.element, 'unlockAssignments');

    assignForm?.classList.remove('contents-loading');
    assignButton?.classList.remove('contents-loading');

    if (assignedTicket.current_topup_amount <= 0) return;
    window.dispatchEvent(new CustomEvent('topup-selection-change'));
  }

  async updateTicketsFriendSelections(
    unnassignedTickets,
    assignmentComponentUrl,
  ) {
    await Promise.all(
      unnassignedTickets.map((ticket) =>
        this.updateComponent({
          componentUrl: assignmentComponentUrl,
          componentSelector: `.ticket-assignment-card[data-ticket-id="${ticket.id}"]`,
          body: { ticket },
        }),
      ),
    );
  }

  async assign_all_checkbox_changed() {
    this.element.closest('form').submit();

    // TODO: For future reference, async assign all
    // const res = await fetch('/ticket_order/ajax_assign_addon_form', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'X-CSRF-Token': this.getMetaValue('csrf-token'),
    //   },
    // })

    // console.log(res)
  }

  setContinueButton(tickets) {
    const hasOutstandingAssignments = tickets.some(
      (ticket) =>
        ticket.assignment_info.requires_assignment &&
        ticket.assignment_info.current_assignment_type === 'unassigned',
    );
    const enabledText = this.continueButtonTarget.dataset.enabledText;
    const disabledText = this.continueButtonTarget.dataset.enabledText;

    if (hasOutstandingAssignments) {
      this.continueButtonTarget.setAttribute('disabled', 'disabled');
      this.drawerContinueButtonTarget.setAttribute('disabled', 'disabled');
    } else {
      this.continueButtonTarget.removeAttribute('disabled');
      this.drawerContinueButtonTarget.removeAttribute('disabled');
    }

    this.continueButtonTarget.textContent = hasOutstandingAssignments
      ? disabledText
      : enabledText;
    this.drawerContinueButtonTarget.textContent = hasOutstandingAssignments
      ? disabledText
      : enabledText;
  }
}
